<template>
  <header v-if="!isEventPage" class="home-header__menu">
    <LocaleLink v-appear:right="{ delay: 300 }" :to="{ name: 'home' }" class="navigation-top__logo">
      <img :src="$t('common.logo')" alt="FEIA" />
    </LocaleLink>

    <nav class="navigation-top__list">
      <LocaleLink v-appear="{ delay: 400 }" :to="{ name: 'home' }" exact class="navigation-top__item -link">
        {{ $t('common.navigation.home') }}
      </LocaleLink>

      <LocaleLink v-appear="{ delay: 450 }" :to="{ name: 'events-annual' }" class="navigation-top__item -link">
        {{ $t('common.navigation.eventsAnnual') }}
      </LocaleLink>

      <LocaleLink v-appear="{ delay: 500 }" :to="{ name: 'events' }" class="navigation-top__item -link">
        {{ $t('common.navigation.allEvents') }}
      </LocaleLink>

      <LocaleLink v-appear="{ delay: 550 }" :to="{ name: 'team' }" class="navigation-top__item -link">
        {{ $t('common.navigation.teamShort') }}
      </LocaleLink>

      <LocaleLink
        v-appear="{ delay: 600 }"
        :to="{ name: 'home', hash: '#contact' }"
        class="navigation-top__item button"
      >
        {{ $t('common.cta.contact') }}
      </LocaleLink>

      <span v-appear="{ delay: 600 }">
        <template v-for="lang in langLinks">
          <RouterLink :key="lang" :to="getLangLink(lang)" class="navigation-top__lang">
            <span class="navigation-top__item -link -alt">{{ lang.toUpperCase() }}</span>
          </RouterLink>
        </template>
      </span>
    </nav>
  </header>
</template>

<script>
// import { supportedLocales } from '@/locales'
import getLocalizedRoute from '@/helpers/getLocalizedRoute'

export default {
  name: 'NavigationHeader',
  computed: {
    langLinks() {
      // return supportedLocales.filter(lang => lang !== this.$i18n.locale)
      return ['en', 'fr'].filter(lang => lang !== this.$i18n.locale)
    },
    isEventPage() {
      return this.$route.name.includes('conference')
    }
  },
  methods: {
    getLangLink(lang) {
      const link = getLocalizedRoute(lang, this.$route)
      return link
    }
  }
}
</script>
